import { useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIEditorPage from 'UIComponents/page/UIEditorPage';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UIEditorToolbar from 'UIComponents/nav/UIEditorToolbar';
import UITabBar from 'UIComponents/nav/UITabBar';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { KOALA } from 'HubStyleTokens/colors';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { trackEvent } from 'automation-ui-canvas/utils/trackingUtils';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { PREVIEW_MODE } from 'automation-ui-canvas/constants/Gates';
import Routes from 'automation-ui-canvas/constants/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
const TitleWrapper = styled.div.withConfig({
  displayName: "PreviewMode__TitleWrapper",
  componentId: "ox1r8l-0"
})(["font-size:18px;font-weight:600;-webkit-font-smoothing:antialiased;"]);
export default function CreateContainer() {
  const scrollElementRef = useRef();
  const isUngatedToPreviewMode = useIsUngated(PREVIEW_MODE);
  const history = useHistory();
  const params = useParams();
  if (!isUngatedToPreviewMode) {
    history.replace(`${Routes.PLATFORM_FLOW}/${params.flowId1}`);
  }
  return /*#__PURE__*/_jsx(UIEditorPage, {
    headerComponent: /*#__PURE__*/_jsx(UIEditorToolbar, {
      startSlot: /*#__PURE__*/_jsx(UIBackButton, {
        onClick: () => {
          trackEvent(Trackables.CLICKED_BACK_TO_WORKFLOWS, undefined, true);
        },
        children: /*#__PURE__*/_jsx(UIRouterLink, {
          use: "on-dark",
          to: "/",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "list.sourceApps.backNavigation.default"
          })
        })
      }),
      titleText: /*#__PURE__*/_jsx(TitleWrapper, {})
    }),
    tabs: /*#__PURE__*/_jsx(UITabBar, {
      bordered: true,
      startSlot: /*#__PURE__*/_jsx("div", {
        className: "p-all-6"
      })
    }),
    hasScrolling: true,
    mainSectionFlush: true,
    scrollDirection: "both",
    scrollElementRef: scrollElementRef,
    use: "default",
    mainBackgroundColor: KOALA,
    children: /*#__PURE__*/_jsx("div", {})
  });
}